module.exports = __webpack_public_path__ + "img/03-min.8207c386.jpg";